import { Navigate, useLocation } from "react-router-dom";

/*
*  有別於 api-base內所建立的token interceptor
*  此component在 render 畫面時作檢查
*  
*  api-base => token interceptor
*  有呼叫httpRequest時運作
*/
export function AuthContext ({children}){
    const access_token = sessionStorage?.getItem('access_token');
    let location = useLocation();
    // console.log(location.pathname.indexOf('idpsso'))
    
    //== 規則 ==
    if(!(location.pathname === '/login' || location.pathname === '/ldap'  || location.pathname === '/mldap' || location.pathname.indexOf('idpsso') > -1))
    {
        if(!access_token){
            return <Navigate to="/login" state={{from:location}} replace/>
        }
    }
    return children;
}